import React from 'react';

import { AddIcon } from 'src/components/icons/AddIcon';
import type { Apollo } from 'src/gql/generated';
import type { WorkflowStep } from 'src/workflow';
import { useDropAction } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

export const stepSeparatorHeightPx = 16;
const useStyles = makeStyles<StyleProps>()((theme, { isOver }) => ({
  blueLine: {
    backgroundColor: theme.palette.primary.main,
    height: 2,
    visibility: isOver ? ('visible' as const) : ('hidden' as const),
    width: '100%',
  },
  plusIcon: {
    color: theme.appColors.primary,
    left: -24,
    position: 'absolute',
    visibility: isOver ? ('visible' as const) : ('hidden' as const),
  },
  stepSeparator: {
    alignItems: 'center',
    display: 'flex',
    height: stepSeparatorHeightPx,
    position: 'relative',
    width: '100%',
  },
}));

interface StyleProps {
  isOver: boolean;
}

interface StepSeparatorProps {
  actionPlacement: Apollo.ActionPlacement.BeforeStep | Apollo.ActionPlacement.AfterStep;
  step: WorkflowStep;
  workflowId: UUID;
}

export function StepSeparator({
  actionPlacement,
  step,
  workflowId,
}: StepSeparatorProps): JSX.Element {
  const [{ isOver: isActionOver }, actionDropRef] = useDropAction({
    actionPlacement,
    targetStepId: step.id,
    workflowId,
  });
  const { classes } = useStyles({ isOver: isActionOver });

  return (
    <div ref={actionDropRef} className={classes.stepSeparator}>
      <AddIcon className={classes.plusIcon} />
      <div className={classes.blueLine} />
    </div>
  );
}
